export default "__VITE_ASSET__BEXRmPEx__"